<!-- =========================================================================================
    File Name: CardStatistics.vue
    Description: Statistics Card
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div>
        <!-- ROW 1 -->
        <div class="vx-row">
        
            <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
                <statistics-card-line icon="UsersIcon"   v-bind:statistic="totalAlumnos"  statisticTitle="Total de Alumnos" 
                :chartData="analyticsData.subscribersGained" type='area'></statistics-card-line>
            </div>
       
            <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
                <statistics-card-line icon="UsersIcon" v-bind:statistic="totalProfesores" statisticTitle="Total de Profesores" 
                :chartData="analyticsData.revenueGenerated" color='success' type='area'></statistics-card-line>
            </div>

            <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
                <statistics-card-line icon="GridIcon" v-bind:statistic="totalGrupos" statisticTitle="Total de Grupos" 
                :chartData="analyticsData.quarterlySales" color='danger' type='area'></statistics-card-line>
            </div>

            <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
                <statistics-card-line icon="DollarSignIcon" v-bind:statistic = "'$' + totalPagoMensual"
                                                            v-bind:statisticTitle = "'Pago del mes de '+ mesCurso" 
                 :chartData="analyticsData.ordersRecevied" color='warning' type='area'></statistics-card-line>
            </div>
        </div>
        <div id="extra-component-chartjs-demo">
            <div class="vx-row">
                <div class="vx-col w-full md:w-1/2">
                    <chartjs-bar-chart></chartjs-bar-chart>                 
                </div>

                <div class="vx-col w-full md:w-1/2">
                <chartjs-pie-chart></chartjs-pie-chart>
            </div>
            </div>
        </div>
    </div>
</template>

<script>
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
import analyticsData from './analyticsData.js'
import ChartjsBarChart from "./ChartjsBarChart.vue"
import ChartjsPieChart from "./ChartjsPieChart.vue"

import BASE from '../../../../vue.config.js'

export default{
    data() {
        return {
            totalAlumnos:0,
            totalProfesores:0,
            totalGrupos:0,
            totalPagoMensual:0,
            mesCurso:'',
            analyticsData: analyticsData,
            statistic:0
        }
    },
    methods: {

        ObtenerDatos(){
         
              fetch(`${BASE.baseUrl}api/ReporteGeneral`, {
                method: 'GET',
                headers: {'Authorization': sessionStorage.getItem('token')}
                })
              .then(rs => rs.json())
              .catch(error => console.log('error:', error))
              .then(rs => {
                if(rs.status == 200){

                    this.totalAlumnos = rs.result.totalAlumnos;
                    this.totalProfesores = rs.result.totalProfesores;
                    this.totalGrupos = rs.result.totalGrupos;
                    this.totalPagoMensual = rs.result.totalPagoMensual;
                    this.mesCurso = rs.result.mesCurso == null ? '' :  rs.result.mesCurso;
                }
              });
        },

    },
    components: {
        StatisticsCardLine,
         ChartjsBarChart,
         ChartjsPieChart,
    },
    mounted(){
       
        this.ObtenerDatos();
    },

}
</script>